<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-forum</v-icon> {{ forum.title }}
    </v-col>
    <template v-if="paginate.total">
      <v-col cols="12" md="4" v-for="topic in topics" :key="topic.id">
        <v-sheet outlined rounded class="fill-height">
          <v-list-item two-line :to="{name: 'ambienteAluno.forum.topics.openTopic', params: {forumId: forumId, topicId: topic.id}}">
            <v-list-item-avatar>
              <v-icon class="accent--text">mdi-forum</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ topic.title }}</v-list-item-title>
              <v-list-item-subtitle>{{ topic.description }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-sheet>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-layout column class="pa-4">
          <v-icon size="124">mdi-emoticon-sad-outline</v-icon>
          <v-flex class="text-center">
            <span>Oops! Não há nenhum tópico para este fórum.</span>
          </v-flex>
        </v-layout>
      </v-col>
    </template>
    <v-col cols="12" class="text-center" v-if="paginate.total">
      <v-pagination v-model="paginate.pageNumber" :length="paginate.length"/>
    </v-col>
    <router-view/>
  </v-row>
</template>

<script>
import { Forum } from '@/services/resources.js'
import { mapGetters } from 'vuex'

export default {
  props: ['forumId'],
  data () {
    return {
      paginate: {
        pageNumber: 1,
        totalVisible: 5,
        total: 0,
        length: 5
      },
      topics: [
        { id: 1, title: 'Tópico1' },
        { id: 2, title: 'Tópico2' },
        { id: 3, title: 'Tópico3' },
        { id: 4, title: 'Tópico4' },
        { id: 5, title: 'Tópico5' }
      ],
      forum: {
        title: 'Fórum'
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    if (this.forumId && from.name !== 'ambienteAluno.forum.topics') {
      this.listTopicsPaginated()
    }

    next()
  },
  mounted () {
    this.listTopicsPaginated()
  },
  methods: {
    listTopicsPaginated () {
      Forum.getTopicsByForum(this.forumId, this.paginate.pageNumber)
        .then((response) => {
          this.topics = response.body.topics.data
          this.paginate.pageNumber = response.body.topics.current_page
          this.paginate.length = response.body.topics.last_page || 5
          this.paginate.total = response.body.topics.total
          this.forum = { ...response.body.forum }
        })
        .catch((error) => {
          console.log('responseError', error)
          if (error.status === 412) {
            this.$toasted.global.error({ message: error.statusText })
            this.$router.push({ name: 'ambienteAluno.forum.index' })
          } else {
            this.$toasted.global.error({ message: error.statusText })
          }
        })
    }
  },
  watch: {
    'paginate.pageNumber': function () {
      this.listTopicsPaginated()
    }
  },
  computed: {
    ...mapGetters({
      user: 'App/user'
    })
  }
}
</script>
